import {useRouter} from 'next/router';
import {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {requestContext} from '../../../common/requestContext';
import {IS_CLIENT_SIDE} from '../../../common/shared/utils/constants';
import useTypedSelector from '../../../common/useTypedSelector';
import {PC_SEARCH_MODAL_ROOT_ID} from '../constant';
import {setOpenPcSearchModal} from '../state/searchSlice';

export function useOpenPcSearchModal() {
  const {openPcSearchModal, openSearchDialog} = useTypedSelector(
    state => state.search
  );
  const {isMobile} = requestContext.requestInfo.display;
  const modalRoot = IS_CLIENT_SIDE
    ? document.getElementById(PC_SEARCH_MODAL_ROOT_ID)
    : null;

  const dispatch = useDispatch();
  const router = useRouter();

  const _setOpenPcSearchModal = useCallback(
    (open: boolean) => {
      dispatch(setOpenPcSearchModal(open));
    },
    [dispatch]
  );
  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (modalRoot?.contains(event.target as HTMLElement)) {
        _setOpenPcSearchModal(true);
      } else {
        _setOpenPcSearchModal(false);
      }
    }
    /** 검색쪽 Dialog가 화면에 보일 때 검색 Modal이 닫히기 않기 위해 이벤트 핸들러를 제거합니다. */
    if (!isMobile && openSearchDialog) {
      window.removeEventListener('click', handleClick);
    } else {
      window.addEventListener('click', handleClick);
    }
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, [_setOpenPcSearchModal, dispatch, isMobile, modalRoot, openSearchDialog]);

  useEffect(() => {
    function handleRoute() {
      _setOpenPcSearchModal(false);
    }
    router.events.on('routeChangeStart', handleRoute);
    return () => {
      router.events.off('routeChangeStart', handleRoute);
    };
  }, [_setOpenPcSearchModal, dispatch, router.events]);

  return {openPcSearchModal, setOpenSearchModal: _setOpenPcSearchModal};
}
